module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-texte__start-wrapper"
  }, [_c('div', {
    staticClass: "ksm-texte__start-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__start"
  }, [_c('div', {
    staticClass: "ksm-merz-container"
  }, [_c('img', {
    staticClass: "ksm-merz-png",
    attrs: {
      "src": "static/icons/schwitters_hefte_2019_01_p01.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ebed7a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/Start.vue
// module id = 1982
// module chunks = 1